export enum WebSocketsTypesEnum {
  WS__START_WEBSOCKET_CONNECTIONS = 'WS__START_WEBSOCKET_CONNECTIONS',
  WS__STOP_WEBSOCKET_CONNECTIONS = 'WS__STOP_WEBSOCKET_CONNECTIONS',
  WS__FAILED_WEBSOCKET_CONNECTIONS = 'WS__FAIL_WEBSOCKET_CONNECTIONS',
  WS__SEND_MESSAGE = 'WS__SEND_MESSAGE',
  WS__RECEIVED_MESSAGE = 'WS__RECEIVED_MESSAGE',
  WS__ERROR = 'WS__ERROR',
  WS__CONNECTED = 'WS__CONNECTED',
  WS__GOING_TO_RECONNECT = 'WS__GOING_TO_RECONNECT',
}

export enum WebSocketsConnectionEnum {
  WS__READER_EVENTS = 'WS__READER_EVENTS',
}

export interface WebSocketMessageBase {
  connectionName: string;
}

export enum WS_SEND_MESSAGE_TYPE {
  PING = 'PING',
  USER_DATA = 'USER_DATA',
}

export interface WebSocketMessageData extends WebSocketMessageBase {
  data: Message;
  error: boolean;
  close: boolean;
}

export interface WebSocketMessageError extends WebSocketMessageBase {
  data: null;
  error: boolean;
  message: string;
  close: boolean;
}

export interface WebSocketMessageClose extends WebSocketMessageBase {
  data: null;
  error: boolean;
  close: boolean;
}

export type WebSocketMessage = WebSocketMessageData | WebSocketMessageError | WebSocketMessageClose;

export type WebSocketAction = {
  type: WebSocketsTypesEnum;
  payload: WebSocketMessage;
  connectionName: string;
};

export interface Message<C = unknown> {
  messageId: string;
  content: C;
  timestamp: number;
}

export type MessagePayloadInnerAction<V = unknown> = {
  actionName: string;
  actionValue: V;
};
